import store from '@/store';
import { LOCAL_STORAGE_BRAND_ID } from '@/utils/constants/checkin.constants';

const guard = async(to, from, next) => {
  if (to.name === 'select-unit' || to.name === 'hostname-url') {
    if (
      (to.name === 'hostname-url' && window.location.hostname.includes('atendimento.dasa')) ||
      (to.name === 'hostname-url' && window.location.hostname.includes('localhost')) ||
      (to.name === 'hostname-url' && window.location.hostname.includes('unit-front'))) {
      next({
        name: 'checkIn',
        params: {
          brandId: store.getters.getBrandUnitIdVariables.brandId,
          unitId: store.getters.getBrandUnitIdVariables.unitId,
        }
      });

      return;
    }

    const brandFromHostName = window.location.hostname.split('.')[0].toLowerCase();
    const brandNameRouteParam = to.params.brandName?.toLowerCase();

    for (const brandId in store.state.brands) {
      const brandNameWhatsApp = store.state.brands[brandId].whatsappName;
      const brandNameUrl = store.state.brands[brandId].urlName.toLowerCase();

      if (
        brandNameUrl === brandNameRouteParam ||
        brandNameUrl === brandFromHostName
      ) {
        localStorage.setItem(LOCAL_STORAGE_BRAND_ID, brandId);
        store.commit('SET_CURRENT_BRAND_NAME_ID', { brandName: brandNameWhatsApp, brandId });
      }
    }
  }

  next();
};

export default guard;
